<template>
  <div id="app">
    <div id="sp-main-body">
      <router-view :key="$route.fullPath"></router-view>
      <linkBlock></linkBlock>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import LinkBlock from './components/LinkBlock'

export default {
  components: { Navbar, LinkBlock }
}
</script>

<style lang="scss">

  // Bootstrap
  $icon-font-path: '../node_modules/bootstrap-sass/assets/fonts/bootstrap/';
  @import 'node_modules/bootstrap-sass/assets/stylesheets/bootstrap';

  // font awesome
  $fa-font-path: '../node_modules/font-awesome/fonts/';
  @import 'node_modules/font-awesome/scss/font-awesome';


  @import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400,400i,700&display=swap');
  @import '../static/css/responsive.scss';
  @import '../static/css/custom.scss';
  @import '../static/css/front.css';
  @import '../static/css/default.css';
  @import '../static/css/template.css';
  @import '../static/css/extra.css';

  @import "~vue-wysiwyg/dist/vueWysiwyg.css";
  @import '~vue-select/dist/vue-select.css';

  body {
    a, p, span {
      font-family: 'Libre Baskerville', serif !important;
      color: black !important;
    }
    font-family: 'Libre Baskerville', serif !important;

  }

</style>



// WEBPACK FOOTER //
// App.vue?472ce1fc